import { useMemo } from 'react'

import { CMS_MICROSITE_ID } from '@lyrahealth-inc/shared-app-logic/src/features/CMSMicrosite/types'

import { useGetMayMentalHealthCustomMessages } from './useGetMayMentalHealthCustomMessages'
import { useGetNewYearCustomMessages } from './useGetNewYearCustomMessages'
import { useGetPaidSocialCustomMessages } from './useGetPaidSocialCustomMessages'

/**
 * Get custom messages for microsite. This is not supported through the metadata since the messages have dynamic components to them, such as session count, and conditional logic.
 */
export const useGetCMSMicrositeCustomMessages = ({ micrositeId }: { micrositeId: CMS_MICROSITE_ID }) => {
  const newYearMessages = useGetNewYearCustomMessages()
  const mayMentalHealthMessages = useGetMayMentalHealthCustomMessages()
  const paidSocialMessages = useGetPaidSocialCustomMessages()

  const messages: { [key in CMS_MICROSITE_ID]?: Dict } = useMemo(() => {
    return {
      [CMS_MICROSITE_ID.NEW_YEAR_TOOLKIT]: newYearMessages,
      [CMS_MICROSITE_ID.MAY_MENTAL_HEALTH]: mayMentalHealthMessages,
      [CMS_MICROSITE_ID.PAID_SOCIAL]: paidSocialMessages,
      [CMS_MICROSITE_ID.WORLD_MENTAL_HEALTH_DAY]: mayMentalHealthMessages, // uses same messages as may mental health
    }
  }, [mayMentalHealthMessages, newYearMessages, paidSocialMessages])

  return useMemo(() => {
    return messages[micrositeId]
  }, [messages, micrositeId])
}
